import { PLATFORM_ID, Injectable, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly platformId = inject(PLATFORM_ID);

  private get storage(): Storage | null {
    return isPlatformBrowser(this.platformId) ? window.localStorage : null;
  }

  get(key: string): any {
    const storage = this.storage;
    if (!storage) return null;

    const value = storage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  set(key: string, value: any): boolean {
    const storage = this.storage;
    if (!storage) return false;

    const objValue = value instanceof Map ? Object.fromEntries(value) : value;
    if (objValue === undefined) return false;

    storage.setItem(key, JSON.stringify(objValue));
    return true;
  }

  remove(key: string): boolean {
    const storage = this.storage;
    if (!storage) return false;

    storage.removeItem(key);
    return true;
  }

  get isLocalStorageSupported(): boolean {
    return !!this.storage;
  }
}
